// import axios from "axios"
// import { Dispatch } from "redux"
// import { MonoAction, MonoActionTypes } from "../types/Mono"



// export const fetchMono = () => {
//    return async (dispatch: Dispatch<MonoAction>) => {
//       try {
//          dispatch({ type: MonoActionTypes.FETCH_MONO })
//          const response = await axios.get(`https://geek-jokes.sameerkumar.website/api?`)
//          setTimeout(() => {
//             dispatch({
//                type: MonoActionTypes.FETCH_MONO_SUCCESS,
//                payload: response.data
//             })
//          }, 500)
//       } catch (error) {
//          dispatch({
//             type: MonoActionTypes.FETCH_MONO_ERROR,
//             payload: "Error"
//          })
//       }
//    }
// }
import axios from "axios";
import { Dispatch } from "redux";
import { MonoAction, MonoActionTypes } from "../types/Mono";

const apiToken = "uravFS7MT4guIEny_e1pJG5WaIcjapSoXuEsy1piGdT4";

export const fetchMono = () => {
  return async (dispatch: Dispatch<MonoAction>) => {
    try {
      dispatch({ type: MonoActionTypes.FETCH_MONO });
      const response = await axios.get(
        "https://api.monobank.ua/personal/client-info",
        {
          headers: {
            "X-Token": apiToken,
          },
        }
      );
      dispatch({
        type: MonoActionTypes.FETCH_MONO_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: MonoActionTypes.FETCH_MONO_ERROR,
        payload: "Error",
      });
    }
  };
};
